import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from '../api.service';
import { ReportGroup, GroupMember } from '../../models/reportgroup';
import { ReturnObject } from '../../models/returnObject';

@Injectable()
export class GroupAdminService {
    constructor(
        private api: APIService) {
    }

    get(email: string): Observable<ReturnObject<ReportGroup[]>> {
        return this.api.getAPI(`groupadmin/${email}`);
    }

    save(group: ReportGroup, email: string, groupName: string): Observable<ReturnObject<ReportGroup[]>> {
        return this.api.postAPI(`groupadmin/${email}/${groupName}`, group);
    }   

    delete(email: string, groupId: number): Observable<ReturnObject<ReportGroup[]>>  {
        return this.api.deleteByEnpointApi(`groupadmin/${email}/${groupId}`);
    } 
}
